import { getPermissions } from '@/api/permission';

type IPermissionInfo = IPermission.IResponse.IPermissionInfo;

export let allPermission: IPermissionInfo[] = [];

export const getAllPermission = (roleId?: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    getPermissions({
      roleId,
    })
      .then((res) => {
        allPermission = sortPermissionsByGroupName(res.data);
        resolve(res.message);
      })
      .catch((err) => {
        reject(err.message);
      });
  });
};

export const generatePermissionComment = (
  permissions: IPermissionInfo[],
): IPermissionInfo[] => {
  return permissions.map((permission) => {
    if (permission.comment) {
      return permission;
    }
    permission.comment = permission.name;
    return permission;
  });
};

export const mergePermissionsByRoles = (
  roles: IRole.IResponse.IRoleInfo[],
  permissions: IPermissionInfo[],
): IPermissionInfo[] => {
  const permissionIds: string[] = permissions.map(
    (permission) => permission.id,
  );
  const newpermissions: IPermissionInfo[] = [...permissions];
  const allPermissions: IPermissionInfo[] = [];
  roles.forEach((role) => {
    if (role.permissions && role.permissions.length > 0) {
      allPermissions.push(...role.permissions);
    }
  });
  allPermissions.forEach((permission) => {
    if (!permissionIds.includes(permission.id)) {
      permissionIds.push(permission.id);
      newpermissions.push(permission);
    }
  });
  return newpermissions;
};

export const generatePermissionNameList = (
  permissions: IPermissionInfo[],
): string[] => {
  return permissions.map((permission) => permission.name);
};

export const sortPermissionsByGroupName = (permissions: IPermissionInfo[]) => {
  const newArr = permissions.slice(0);
  const groupNames = [...new Set(newArr.map((item) => item.groupName))].sort();
  const sortByGroupName = (
    permissionA: IPermissionInfo,
    permissionB: IPermissionInfo,
  ) => {
    return (
      groupNames.indexOf(permissionA.groupName) - groupNames.indexOf(permissionB.groupName)
    );
  };
  return newArr.sort(sortByGroupName);
};
